/**
 * Since ExtJs 2.2.1 email vtype doesn't accept valid email addresses that contain anything other than (A-Za-z0-9_.)
 * Added more RFC compliant regex with one edge case - it will return true if address is ending on "-.domain" which is wrong
 * but javascript regex doesn't have lookbehind that needed to eliminate that case
 */
Ext.form.VTypes['emailAddressMask'] = /[a-zA-Z\d!#$%&'*+\-\/=?^_`{|}~@\.]/;
Ext.form.VTypes['emailAddressText'] = 'This field should be a valid email address';
Ext.form.VTypes['emailAddress'] = function(v) {
    return /^(\.?[a-zA-Z\d!#$%&'*+\-?^_`{|}~]+)+@((?!-)[a-zA-Z\d\-]+\.)+[a-zA-Z]{2,}$/.test(v);
};
